export default (key: string) => {
  const { $t } = useNuxtApp()
  return $t(key)
}
